import request from '@/utils/request'

//经销商资料
export function miMemberInfo(query) {
    return request({
        url: 'common/miMemberInfo',
        method: 'get',
        params: query
    })
}

//代办处资料
export function miAgentInfo(query) {
    return request({
        url: 'common/miAgentInfo',
        method: 'get',
        params: query
    })
}

// 验证安置人市场个数
export function miMemberRightNum(query) {
    return request({
        url: 'common/miMemberRightNum',
        method: 'get',
        params: query
    })
}

// 获取制度
export function getCompanyBonusType(query) {
    return request({
        url: 'common/getCompanyBonusType',
        method: 'get',
        params: query
    })
}

//账户合计
export function balanceSum(query) {
    return request({
        url: 'account/balanceSum',
        method: 'get',
        params: query
    })
}

// 一级地区列表(国家)
export function getLevel1AlRegions(query) {
    return request({
        url: 'common/getLevel1AlRegions',
        method: 'get',
        params: query
    })
}

//根据地区编码获取其下属地区
export function getAlRegionsByCode(query) {
    return request({
        url: 'common/getAlRegionsByCode',
        method: 'get',
        params: query
    })
}

//根据地区ID获取其下属地区
export function getAlRegionsByID(query) {
    return request({
        url: 'common/getAlRegionsByID',
        method: 'get',
        params: query
    })
}
